"use client";

import { useEffect, useState } from "react";

export default function useIsClient() {
  // Add client-side detection for hydration consistency
  //https://nextjs.org/docs/messages/react-hydration-error
  const [isClient, setIsClient] = useState(false);

  // Mark when hydration is complete
  useEffect(() => {
    setIsClient(true);
  }, []);

  return isClient;
}
